module.exports = __webpack_public_path__ + "static/media/true.d4020a04.svg";